import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFragile from '@fortawesome/fontawesome-pro-light/faFragile';

import T from './Translate';

class Error extends Component {

	render() {
		return (
			<section className="container final-step">
				<div className="final-step-icon">
					<div>
						<div className="final-step-icon__bg final-step-icon__bg--under final-step-icon__bg--error" />
						<div className="final-step-icon__bg final-step-icon__bg--under2 final-step-icon__bg--error" />
						<div className="final-step-icon__bg final-step-icon__bg--error" />
						<FontAwesomeIcon icon={faFragile} className="final-step-icon__icon" />
					</div>
				</div>

				<h1 className="final-step__title"><T id="Error.title" /></h1>
				<h2 className="final-step__subtitle"><T id="Error.subtitle" /></h2>
			</section>
		)
	}
}

export default Error;



// WEBPACK FOOTER //
// ./src/components/Error.jsx